module.exports = __webpack_public_path__ + "static/media/starPodAll.d21e2240.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/starPodAll.png
// module id = 856
// module chunks = 0